// Hotel

import React, { useState, useEffect } from "react";
import _ from "lodash";
import {
  ReceiptRow,
  ReceiptHeader,
  ReceiptGroup,
  ReceiptGroupRow,
  ReceiptGroupRow2
} from "./ReceiptRow";
import { Radio, useRadioViewButtons } from "./Components";
import { GroupDateTable } from "./ReceiptGroupDateRow";
import { groupByDate } from "../../../shared/utils/receipts";
import axios from "axios";
import { downloadableLinkUrl } from "../../../shared/utils";
import { useDispatch } from "react-redux";
import * as appStateAction from "../../../shared/actions/appStateActions";
import Select from "react-select";

function DashboardSales(props) {
  const { receipts, receipts_entertain, dashboardDispatch } = props;
  const [dataGroups, setDataGroups] = useState([]);
  const [therapistGroupsByDate, setTherapistGroupsByDate] = useState({});

  const [view, Component] = useRadioViewButtons("summary", { groupDate: true });
  const dispatch = useDispatch();

  const [filterSales, setFilterSales] = useState([]);

  function viewCallback(receipt) {
    dashboardDispatch({
      type: "SET_MODAL",
      payload: {
        data: receipt,
        visible: true
      }
    });
  }

  useEffect(() => {
    if (view === "date") {
      let res = groupByDate(receipts, "sales");
      setTherapistGroupsByDate(res);
    }
  }, [view, receipts]);

  useEffect(() => {
    let _res = computeGroup(receipts);
    setDataGroups(_res);
  }, [receipts]);

  const downloadPdf = () => {
    let URL =
      "https://asia-east2-niceloop-dev.cloudfunctions.net/PDFSummaryByDate";
    let data = {
      mode: "Sales",
      startDate: props.startDate,
      endDate: props.endDate,
      shopId: props.shop.uid,
      filter: filterSales.length > 0 ? filterSales : null
    };

    dispatch(appStateAction.loading(true));

    axios
      .post(URL, data)
      .then(res => {
        downloadableLinkUrl("report-summary-excel.xlsx", res.data);
      })
      .catch(err => alert(err))
      .finally(() => {
        dispatch(appStateAction.loading(false));
      });
  };

  return (
    <div class="">
      <div class="col-lg-12">
        <div class="card card-table">
          <div class="card-header">
            {Component}
            Group by {_.keys(dataGroups).length} Agents
            <span style={{ marginLeft: 36, color: "blue" }}>
              found {_.reduce(dataGroups, (acc, v) => acc + v.length, 0)} bills
              from {receipts.length} bills
            </span>
            <div className="row m-0">
              <div className="col-6 pl-0">
                <Select
                  isMulti
                  value={filterSales}
                  onChange={setFilterSales}
                  options={props.salesOptions}
                  placeholder="All"
                />
              </div>
              <div>
                <button
                  class="btn btn-space btn-secondary"
                  onClick={downloadPdf}
                >
                  Export PDF
                </button>
              </div>
            </div>
          </div>
          <div class="card-body pb-7">
            {view !== "date" && (
              <table class="table table-small table-striped">
                {view === "detail" && (
                  <ReceiptHeader showAgent={false} showTherapist={false} />
                )}
                <tbody>
                  {_.map(dataGroups, (receipts, gName) => {
                    return [
                      <ReceiptGroupRow2
                        name={gName}
                        col1Text={
                          "GrandTotal : " +
                          _.sumBy(receipts, "payment.grandTotal") +
                          ` (${receipts.length})`
                        }
                      />,
                      view === "detail" &&
                        _.map(receipts, (r, index) => (
                          <ReceiptRow
                            viewCallback={() => viewCallback(r)}
                            showAgent={false}
                            showTherapist={false}
                            linkToKey="cityLedger"
                            showVoidButton={false}
                            index={index + 1}
                            {...r}
                          />
                        ))
                    ];
                  })}
                </tbody>
              </table>
            )}

            {view === "date" && [
              <div class="row">
                <div class="col-2"> </div>
                <div class="col-8">
                  {" "}
                  <GroupDateTable
                    showPaymentType={true}
                    groupReceiptsByDateHolder={therapistGroupsByDate}
                  />{" "}
                </div>
              </div>
            ]}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardSales;

function computeGroup(receipts) {
  let onlySales = _.filter(receipts, r => r.sales);

  return _.groupBy(onlySales, r => {
    return (r.sales && r.sales.name) || "UNKNOWN";
  });
}
